import getStore from '../store/store';
import RetentionPoliciesListOptionState from '../store/schema/RetentionPoliciesListOptionState';
import { ActiveRetentionPolicyRowType } from '../store/schema/RetentionPolicyRowType';

export default function getActivePoliciesListState(): RetentionPoliciesListOptionState<
    ActiveRetentionPolicyRowType
> {
    return getStore().activePoliciesListState;
}
